import { ArcadaSomenteLeitura } from "@/components/odontograma/ArcadaSomenteLeitura";

/** Odontograma somente-leitura — mostra os dentes de um serviço já salvo (sem seleção/edição).
 *  `soArcadaUsada`: só a arcada com dente marcado, maior no mesmo espaço. */
export function ProsthesisTeethDisplay({
  teeth,
  largura,
  soArcadaUsada,
}: {
  teeth: string | null | undefined;
  largura?: number;
  soArcadaUsada?: boolean;
}) {
  return <ArcadaSomenteLeitura dentes={teeth} largura={largura} soArcadaUsada={soArcadaUsada} />;
}
